import { required, email } from 'vuelidate/lib/validators';

export default {
  validations: {
    email: { required, email },
    password: {
      required,
    },
  },

  computed: {
    errorEmailEmptyField() {
      return this.$v.email.$dirty && !this.$v.email.required;
    },
    errorEmailInvalidField() {
      return this.$v.email.$dirty && !this.$v.email.email;
    },
    errorPasswordField() {
      return this.$v.password.$dirty && !this.$v.password.required;
    },
    emailErrorText() {
      if (!this.$v.email.required) {
        return this.$t('error.required_field');
      }
      if (!this.$v.email.email) {
        return this.$t('error.invalid_email');
      }
    },
  },
  methods: {
    showAuthValidationErrors() {
      this.$v.$touch();
    },
  },
};
